import React from 'react';

import Swal from 'sweetalert2'
// import { checkAuthentication } from '../../includes/functions';
// import "font-awesome/css/font-awesome.css";
function ErrorHandler(error, props, return_error_message) {
    let popError = true;
    let status = 'network_error';
    if (error.response && error.response.status) {
        status = error.response.status;
    }
    // let status = 200
    let errorMessage = '';

    if (status === 401) {
        errorMessage = 'Session Expired'
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        window.location = '/login'
    }
    else if (status === 400) {
        //institutes/academicyear/1(Getting this response when making edit to academic year)
        let errorData = null;
        let isArray = false;
        if (error.response.data && Array.isArray(error.response.data)) {
            errorData = error.response.data;
            isArray = true;
        }
        else if (error.response.data && !Array.isArray(error.response.data)) {
            errorData = error.response.data;
        }
        if (errorData) {
            for (const index in errorData) {
                let data = errorData;
                if (isArray) {
                    data = errorData[index];
                    if (typeof (data) === 'object') {
                        let keys = Object.keys(data);
                        keys.some((keyData) => {
                            let value = data[keyData][0];
                            errorMessage = errorMessage + keyData + ': ' + value;
                        });
                    }
                    else {
                        const value = index === 0 ? data : ' ' + data;
                        errorMessage = errorMessage + value;
                    }
                }
                else {
                    let keys = Object.keys(data);
                    keys.some((keyData) => {
                        let value = data[keyData][0];
                        errorMessage = errorMessage + keyData + ': ' + value;
                    });
                }
            }
        }
    }
    else if (status === 403) {
        errorMessage = 'Page not Found'
        // window.location = '/dashboard'
    }
    else if (status === 405) {
        //adddmission student form delete
        errorMessage = error.response.data.detail;
    }
    else if (status === 'network_error') {
        errorMessage = 'Make sure your device has an active Internet connection.';
    }
    else {
        errorMessage = 'Something went wrong!!';
    }
    if (props && Boolean(props['return_error_message'])) {
        return errorMessage;
    }
    else {
        Swal.fire({
            type: 'error',
            title: 'Error',
            text: errorMessage,
        })
    }
    if (Boolean(return_error_message)){
        return errorMessage;
    }
}

export default ErrorHandler;